const pallet = {
  B400: '#0052CC',
  G400: '#00875A',
  Y400: '#FF991F',
  R400: '#DE350B',
  B50: '#DEEBFF',
  G50: '#E2FFEE',
  Y50: '#FFFAE6',
  R50: '#FFEBE5',
  DS50: '#9DB7DC',
  N800: '#172B4D',
  N300: '#5E6C84',
  N100: '#7A869A',
  N50: '#C1C7D0',
  N40: '#DFE1EE',
  N20: '#F4F5F7',
  N0: '#FFFFFF',
  white: '#FFFFFF',
  success: '#1EAF67',
  error: '#FC0A4C',
  textLight: '#A6A6A6',
  B0: '#DEE2E6',
  primary: '#7A5AF8',
  primaryHover: '#6853de',
  primaryDisabled: '#eae7fe',
  vgChipBackground: '#F5F6F8',
  hashtagModalChipBackground: '#F3F3F3',
  filtersChipBorder: '#E8E8E8',
  textDefault: '#2B2A29',
  textGrey: '#707070',
  textFeedback: '#182B4D',
  disabledGrey: '#AEADAD',
  shadowLight: '#0000001A', // 10% opacity black
  shadowMedium: '#00000026', // 15% opacity black
  shadowDefault: '#00000027', // 15.3% opacity black
  shadowSubtle: '#0000000D', // 5% opacity black
  divider: '#DFE1EE',
  borderBackground: '#F4F6F8',
  selectedBackground: '#E5E6FD',
  notificationBackground: '#D9D6FE',
  lightYellow: '#FFFDF2',
  borderYellow: '#FFF1A7',
  lightViolet: '#6E6F9F',
  primaryColorShadow: '#696CFF',
  red: '#FC0A4C',
  navigationItems: '#00000099',
  lightGrey: '#f5f5ff',
  lightGrey2: '#e1e1e1',
  secondaryHover: '#e8e8ff',
  lightRed: '#F63D6829',
  lightGreen: '#16b36414',
  green2: '#16b364',
  red2: '#F63D68',
  skyBlue: '#e3f2fd',
  blue: '#1976d2',
  textLabel: '#101828',
  black: '#000',
  formLabelText: '#0E0C0BE5',
  lightBlueText: '#0E0C0BB2',
  dividerLine: '#EEEEEE',
  greenBg: '#16B364',
  successMain: '#16B364',
  greenShadow: '#71DD3766',
  aqua: '#06AED4',
  hoverBlue: '#7A5AF829',
  hoverAction: '#0E0C0B0F',
  grayBackground: '#FAFAFA',
  grayborder: '#E9EAEB',
  buttonShadow: '#696CFF66',
  boxShadow: '#22303E1A',
  yellowBackground: '#FAC51529',
  yellowAlertText: '#EAAA08',
  tableHeaderBorder: '#0E0C0B1F',
  border: '#F5F5F5',
  overlayLight: 'rgba(255, 255, 255, 0.7)',
  greyText: '#0E0C0B66',
  unlinkRed: '#F63D68',
  unlinkBoxShadow: '#FF3E1D66',
  borderGrey: '#e0e0e0',
  disabled: '#0E0C0B0F',
  disabledBorder: '#0E0C0B38',
  fileUploadBox: '#0E0C0B38',
  uploadProgress: '#9B8AFB',
  progressBackground: '#D9D9D9',
  radioButtonShadow: '#6A5CFF99',
  radioButtonBorder: '#B5B5B5',
  rowTextColor: '#565554'
};

export default pallet;
